import React from 'react'

import { LocationSelection } from 'discover'

export class LocationSelectionButton extends React.Component {
  label() {
    if (this.props.bounds) {
      return this.props.bounds.label
    } else {
      return LocationSelection.neutralLabel
    }
  }

  render() {
    return <a onClick={ this.props.showModal }>{ this.label() }</a>
  }
}
